import React, { ReactNode, useEffect, useState } from 'react'

import { checkLocale, getLocale } from '@toasttab/buffet-pui-locale-utilities'
import {
  addResources,
  customTranslationMethods,
  hasResourceBundle,
  initI18Next
} from '@toasttab/buffet-pui-translation-utilities'

import defaultStringsEnUS from './locales/en-US.json'

const defaultStrings = defaultStringsEnUS

function flattenObject(ob: any, prefix = ''): Record<string, string> {
  return Object.keys(ob).reduce((toReturn, k) => {
    const pre = prefix.length ? prefix + '.' : ''
    if (typeof ob[k] === 'object' && ob[k] !== null) {
      Object.assign(toReturn, flattenObject(ob[k], pre + k))
    } else {
      toReturn[pre + k] = ob[k]
    }
    return toReturn
  }, {} as Record<string, string>)
}

const flattenedStrings = flattenObject(defaultStringsEnUS)
export type AppStrings = Record<keyof typeof flattenedStrings, string>

const spaName = 'sites-web'

export const { t, Trans } = customTranslationMethods<AppStrings>(spaName)

export async function loadTranslations() {
  const locale = getLocale()
  if (!hasResourceBundle(locale, spaName)) {
    addResources('en-US', spaName, defaultStrings)
    try {
      const localeStrings = require(`./locales/${locale}.json`)
      addResources(locale, spaName, localeStrings)
    } catch {
      addResources(locale, spaName, defaultStrings)
    }
  }
}

export type I18nConfig = {
  locale: string
  currency: string
  country: string
}

export async function initLocalI18next(
  i18nConfig: I18nConfig,
  userPreferredLocale?: string
) {
  const localeToUse = userPreferredLocale || i18nConfig.locale
  // @ts-ignore
  initI18Next(checkLocale(localeToUse))
}

interface DecoratorContext {
  globals: {
    theme?: string
    backgrounds?: {
      value?: string
    }
    locale: string
  }
  canvasElement?: HTMLElement
}

type Decorator = (
  Story: React.ComponentType,
  context: DecoratorContext
) => ReactNode

export const LoadTranslationsDecorator: Decorator = (Story, context) => {
  const [_, setTranslationsLoaded] = useState(false)

  useEffect(() => {
    setTranslationsLoaded(false)
    loadTranslations().then(() => {
      setTranslationsLoaded(true)
    })
  }, [context.globals.locale])
  return <Story />
}
